import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import UsersCreateContent from "../../../components/Pages/Users/Create";
import SurveyCreateContent from "../../../components/Pages/Survey/create";

const { displayName } = config;

export default function SurveyCreate(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Survey Create`;
  }, []);

  return (
    <Layout>
      <SurveyCreateContent />
    </Layout>
  );
}
